function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "6011C67B-6A25-4FCA-BDC5-DE0C7CA0C04A");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Design-systems",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Form-elements",
  transform: "translate(-788.000000, -785.000000)",
  fill: "#42526E"
}, React.createElement("g", {
  id: "icon/transfers",
  transform: "translate(788.000000, 785.000000)"
}, React.createElement("path", {
  d: "M13.2998338,7.0000875 C13.6869289,7.0000875 13.999825,7.31298359 13.999825,7.70007875 L13.999825,13.3000087 C13.999825,13.6871039 13.6869289,14 13.2998338,14 L0.69999125,14 C0.312896089,14 0,13.6871039 0,13.3000087 L0,7.70007875 C0,7.31298359 0.312896089,7.0000875 0.69999125,7.0000875 L4.1999475,7.0000875 C4.58704266,7.0000875 4.89993875,7.31298359 4.89993875,7.70007875 C4.89993875,8.08717391 4.58704266,8.40007 4.1999475,8.40007 L1.3999825,8.40007 L1.3999825,12.6000175 L12.5998425,12.6000175 L12.5998425,8.40007 L9.7998775,8.40007 C9.41278234,8.40007 9.09988625,8.08717391 9.09988625,7.70007875 C9.09988625,7.31298359 9.41278234,7.0000875 9.7998775,7.0000875 L13.2998338,7.0000875 Z M6.9999125,11.200035 C6.61281734,11.200035 6.29992125,10.8871389 6.29992125,10.5000437 L6.29992125,5.600105 C6.29992125,3.67022912 7.87000162,2.10014875 9.7998775,2.10014875 L11.6100549,2.10014875 L10.7049662,1.19506006 C10.4312696,0.921363483 10.4312696,0.478969013 10.7049662,0.205272434 C10.9786628,-0.0684241447 11.4210572,-0.0684241447 11.6947538,0.205272434 L13.7947276,2.30524618 C14.0684241,2.57894276 14.0684241,3.02133723 13.7947276,3.29503381 L11.6947538,5.39500756 C11.5582555,5.53150586 11.3790578,5.600105 11.19986,5.600105 C11.0206622,5.600105 10.8414645,5.53150586 10.7049662,5.39500756 C10.4312696,5.12131098 10.4312696,4.67891651 10.7049662,4.40521993 L11.6100549,3.50013125 L9.7998775,3.50013125 C8.64209197,3.50013125 7.69990375,4.44231947 7.69990375,5.600105 L7.69990375,10.5000437 C7.69990375,10.8871389 7.38700766,11.200035 6.9999125,11.200035 Z",
  id: "Shape"
}))));

var SvgTransferIcon = function SvgTransferIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTransferIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transfer-icon.a9bd6228.svg";
export { ForwardRef as ReactComponent };